// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter")
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", event => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-drawer-items") ||
        this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll("shipping-bar");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== "updates[]") return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add("is-loading");

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace =
            document.querySelector(section.selector) ||
            document.querySelector(section.id);

          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }
        });
        if (!parsedState.errors) {
          this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        }
        this.updateLiveRegions(
          line,
          parsedState.item_count,
          parsedState.errors
        );

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateCartCounters();

        // počkaj 10 ms, kým DOM nahradí shipping-bar
        setTimeout(() => {
          updateFreeShipping();
        }, 10);
      })
      .finally(() => this.classList.remove("is-loading"));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define("cart-items", CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      event => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () =>
      this.open()
    );
    this.parentElement.addEventListener("shopify:section:deselect", () =>
      this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error("Cart link not found");
    }
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector("body").style.overflow = "hidden";
    this.addEventListener(
      "transitionend",
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    const productReccomendations = document.querySelector(
      ".product-recommendations"
    );
    if (productReccomendations) {
      if (productReccomendations.classList.contains("hidden")) {
        document
          .querySelector(".cart-drawer-items")
          .classList.add("cart-drawer-items__full");
      } else {
        document
          .querySelector(".cart-drawer-items")
          .classList.remove("cart-drawer-items__full");
      }
    }

    celebrateFreeShipping();
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector("body").style.overflow = "auto";
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );

      updateCartCounters();
    });
    if (!open) {
      return;
    }

    this.open();

    // ensure free shipping bar updates after drawer refresh
    setTimeout(() => updateFreeShipping(), 10);
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

// ---------------------------
//  Free shipping logic
// ---------------------------
// <swiper-component> only initialises on window "load", so sliders that arrive with a
// re-rendered cart drawer (e.g. the Bestsellers row of the empty state) must be initialised manually.
function initCartDrawerSwipers() {
  document.querySelectorAll("cart-drawer swiper-component").forEach(el => {
    if (!el.swiper && typeof el.init === "function") el.init();
  });
}

async function updateFreeShipping() {
  initCartDrawerSwipers();
  const bar = document.querySelector("shipping-bar");
  if (!bar) return;

  const textElement = bar.querySelector(".progress-bar__text");
  const progressBar = bar.querySelector("[data-progress-line]");
  if (!textElement || !progressBar) return;

  let cart;
  try {
    const resp = await fetch("/cart.js");
    cart = await resp.json();
  } catch (e) {
    console.error("updateFreeShipping fetch error", e);
    return;
  }

  const total = cart.total_price || 0;
  const threshold = parseInt(bar.dataset.shippingThreshold || "0", 10);
  if (!threshold) {
    // threshold not configured
    return;
  }

  const difference = threshold - total;

  // show / hide bar (hidden when cart empty)
  if (total === 0) {
    bar.style.visibility = "hidden";
  } else {
    bar.style.visibility = "visible";
  }

  // TEXT
  if (difference > 0) {
    textElement.innerHTML = `You’re <strong>${(difference / 100).toFixed(
      2
    )}€</strong> away from free shipping 👀`;
  } else {
    textElement.textContent = `Free shipping? Unlocked! 🎉`;
  }

  // PROGRESS
  let percent = (total / threshold) * 100;
  percent = Math.max(0, Math.min(100, percent));
  progressBar.style.width = percent + "%";

  // CLASS FOR COLORS/STYLES
  if (difference <= 0) {
    bar.classList.add("free-shipping-reached");
  } else {
    bar.classList.remove("free-shipping-reached");
  }

  // threshold reached by changing the cart while the drawer is open (e.g. + on a line item)
  celebrateFreeShipping();
}

// Ensure free shipping bar updates on page load
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => updateFreeShipping(), 50);
});

// ---------------------------
//  Free shipping confetti
//  Fires once, the first time the cart drawer is opened after the free shipping
//  threshold has been reached. Re-arms when the cart drops below the threshold.
// ---------------------------
const FREE_SHIPPING_CONFETTI_KEY = "tm_free_shipping_confetti";

let freeShippingCelebrationInFlight = false;

async function celebrateFreeShipping() {
  // guard against parallel calls (drawer open + cart update fire together)
  if (freeShippingCelebrationInFlight) return;
  freeShippingCelebrationInFlight = true;

  try {
    const bar = document.querySelector("shipping-bar");
    const threshold = parseInt(
      (bar && bar.dataset.shippingThreshold) || "0",
      10
    );
    if (!threshold) return;

    let cart;
    try {
      cart = await (await fetch("/cart.js")).json();
    } catch (e) {
      return;
    }

    // below threshold -> re-arm for the next time it is reached
    if ((cart.total_price || 0) < threshold) {
      try {
        localStorage.removeItem(FREE_SHIPPING_CONFETTI_KEY);
      } catch (e) {}
      return;
    }

    // celebrate only while the cart drawer is visible
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || !drawer.classList.contains("is-visible")) return;

    // celebrate once per cart: the flag stores the cart token, so a new cart
    // (e.g. after a completed order) celebrates again
    const cartKey = cart.token || "1";
    let seen = false;
    try {
      seen = localStorage.getItem(FREE_SHIPPING_CONFETTI_KEY) === cartKey;
    } catch (e) {}
    if (seen) return;

    try {
      localStorage.setItem(FREE_SHIPPING_CONFETTI_KEY, cartKey);
    } catch (e) {}

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    setTimeout(launchConfetti, 300);
  } finally {
    freeShippingCelebrationInFlight = false;
  }
}

function launchConfetti() {
  // Confetti stays inside the cart drawer panel only.
  const drawerPanel = document.querySelector(".cart-drawer__inner");
  if (!drawerPanel) return;
  const rect = drawerPanel.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  const width = rect.width;
  const height = rect.height;

  const canvas = document.createElement("canvas");
  canvas.setAttribute("aria-hidden", "true");
  Object.assign(canvas.style, {
    position: "fixed",
    left: rect.left + "px",
    top: rect.top + "px",
    width: width + "px",
    height: height + "px",
    pointerEvents: "none",
    zIndex: "2147483647"
  });
  const dpr = window.devicePixelRatio || 1;
  canvas.width = width * dpr;
  canvas.height = height * dpr;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);

  const colors = ["#09090B", "#2B1FD6", "#F472B6", "#FBBF24", "#34D399", "#60A5FA"];
  const count = width < 500 ? 90 : 130;
  const pieces = Array.from({ length: count }, () => ({
    x: Math.random() * width,
    y: -20 - Math.random() * height * 0.4,
    w: 6 + Math.random() * 6,
    h: 8 + Math.random() * 8,
    vx: -1.5 + Math.random() * 3,
    vy: 2 + Math.random() * 3.5,
    rot: Math.random() * Math.PI * 2,
    vr: -0.2 + Math.random() * 0.4,
    sway: Math.random() * Math.PI * 2,
    color: colors[Math.floor(Math.random() * colors.length)]
  }));

  const duration = 3800;
  const start = performance.now();

  function frame(now) {
    const elapsed = now - start;
    // follow the drawer while it slides in
    const r = drawerPanel.getBoundingClientRect();
    canvas.style.left = r.left + "px";
    canvas.style.top = r.top + "px";
    ctx.clearRect(0, 0, width, height);
    const fade = elapsed > duration - 800 ? Math.max(0, (duration - elapsed) / 800) : 1;

    pieces.forEach(p => {
      p.sway += 0.05;
      p.x += p.vx + Math.sin(p.sway) * 0.8;
      p.y += p.vy;
      p.vy += 0.03;
      p.rot += p.vr;
      ctx.save();
      ctx.globalAlpha = fade;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    });

    if (elapsed < duration) {
      requestAnimationFrame(frame);
    } else {
      canvas.remove();
    }
  }

  requestAnimationFrame(frame);
}
